import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { selectBalancingSkipProductionFactor } from "../../balancingSelectors/selectBalancingConstants";
import { selectResourceInfo } from "../../balancingSelectors/selectBalancingResources";
import { IdResource } from "../../constants/IdResource";
import { IdStyles } from "../../less/IdStyles";
import { selectProductionResourceTotalBuffAmount } from "../../selectors/selectBuffsInfo";
import { selectRecipeFactorAddition, selectRecipeInfo } from "../../selectors/selectRecipeInfo";
import { getResourceIcon } from "../generic/icon/getResourceIcon";
import { ResourceIcon } from "../generic/icon/ResourceIcon";
import { actionProductionSkip } from "../info/production/actionProductionInfo";
import { ContextMenuRunningProcess } from "./ContextMenuRunningProcess";
var mapState = function (state) {
    var selectedBuilding = state.playerBase.buildings.building;
    var production = selectedBuilding.production;
    // Just setting an existing value so we don't get unhandled exception
    var resourceId = IdResource.Money;
    var resourceAmount = 0;
    if (production != undefined) {
        var recipe = production.recipe;
        resourceId = recipe.product[0].resourceId;
        resourceAmount = recipe.product[0].amount;
    }
    var resource = selectResourceInfo(resourceId);
    var boosterRecipe = selectRecipeInfo(state, production ? production.production.boosterId : undefined);
    var mainIcon = getResourceIcon(resource);
    var secondaryResource = boosterRecipe ? boosterRecipe.cost[0] : undefined;
    var secondaryResourceElement = (React.createElement(ResourceIcon, { resource: secondaryResource, styleId: IdStyles.IconMedium }));
    var buffRecipe = production && production.production
        ? selectRecipeInfo(state, production.production.boosterId)
        : undefined;
    var multiplier = selectRecipeFactorAddition(buffRecipe);
    var totalBuffAmount = selectProductionResourceTotalBuffAmount(state, resourceId, Long.fromNumber(resourceAmount), multiplier);
    return {
        baseAmount: resourceAmount,
        buffAmount: totalBuffAmount,
        children: secondaryResourceElement,
        getProcessRemainingTime: function (building) {
            var prod = building.production.production;
            return prod.remainingTime;
        },
        getProcessTotalTime: function (building) {
            return building.production ? building.production.recipe.productionTime : undefined;
        },
        icon: mainIcon,
        skipProcessFactor: selectBalancingSkipProductionFactor(),
        tooltipLoca: resource.locaKey,
    };
};
var mapDispatch = function (dispatch) { return ({
    onSkip: function (building) { return dispatch(actionProductionSkip(building)); },
}); };
export var ContextMenuBuffedRunningProductionDOM = connect(mapState, mapDispatch)(ContextMenuRunningProcess);



//////////////////
// WEBPACK FOOTER
// ./src/features/context-menu/ContextMenuBuffedRunningProductionDOM.tsx
// module id = 2245
// module chunks = 3